import * as React from "react";
import { Stack, Box, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { NavigationType } from "@/components/header/common/header-enums";
import { useTranslations } from "next-intl";

type MobileTertiaryHeaderProps = {
  tertiaryHeaderLabel: string;
  tertiaryHeaderLearnMoreUrl: string;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};
export default function MobileTertiaryHeader(props: MobileTertiaryHeaderProps) {
  const { tertiaryHeaderLabel, tertiaryHeaderLearnMoreUrl, setActiveNavigation } = props;
  const t = useTranslations("COMMON");
  return (
    <Stack
      sx={{
        position: "fixed",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        zIndex: 1001,
        width: "100%",
        height: "65px",
        boxShadow: 10,
        backgroundColor: "background.default",
        overflowX: "hidden"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          height: "100%",
          width: "100%",
          justifyContent: "space-between"
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "65px",
            alignItems: "center",
            pl: 2,
            cursor: "pointer",
            flexShrink: 0
          }}
          onClick={() => { setActiveNavigation(NavigationType.secondary); }}>
          <KeyboardArrowLeftIcon
            sx={{
              display: "block",
              fontSize: "2.5rem",
              fontWeight: "600",
              marginTop: "1rem",
              mb: 1.2
            }}
          />
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "400",
              color: "text.primary"
            }}
          >
            {t("Back")}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 0,
            px: "0.4rem"
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "25px",
              fontWeight: "500",
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {tertiaryHeaderLabel}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            height: "65px",
            alignItems: "center",
            cursor: tertiaryHeaderLearnMoreUrl ? "pointer" : "default",
            flexShrink: 0
          }}
          onClick={() => { if (tertiaryHeaderLearnMoreUrl) window.location.href = tertiaryHeaderLearnMoreUrl; }}>
          {tertiaryHeaderLearnMoreUrl && (
            <>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: "400",
                  color: "text.primary",
                  whiteSpace: "nowrap"
                }}
              >
                {t("Learn More")}
              </Typography>
              <KeyboardArrowRightIcon
                sx={{
                  display: "block",
                  fontSize: "2.5rem",
                  fontWeight: "600"
                }}
              />
            </>
          )}
        </Box>
      </Box>
    </Stack>
  );
}

